export default __webpack_public_path__ + "static/media/eudsl-logo.51b07ee9.jpg";